<div class="component-main">
    <div class="content-space-between">
        <h1>{{ 'manage_acls' | myLbTranslate }}</h1>
        <button
            id="manage-acls-add-acl"
            class="primary"
            [disabled]="!frontends.length || !permissionsLookup['manage-acls-add-acl']"
            (click)="openACLWizard()">
            {{ 'manage_acls_add' | myLbTranslate }}
        </button>
    </div>
    <app-table
        id="manage-acls"
        [data]="tableRows"
        [showPaginator]="false"
        [stickyHeader]="true">
        <app-column [flexGrow]="1" prop="frontend" label="frontend" [cellTemplate]="aclDetails">
            <ng-template let-row #aclDetails>
                <button
                    class="routerLink"
                    id="manage-services-service-details"
                    [disabled]="!permissionsLookup['manage-acls-acls-details']"
                    [routerLink]="['acls-details', row.templateType, row.frontendId]">
                    {{ row.frontendLabel }}
                </button>
            </ng-template>
        </app-column>
        <app-column [flexGrow]="0.5" prop="aclsCount" label="count"></app-column>
        <app-column [flexGrow]="1" prop="conditions" label="condition"></app-column>
        <app-column [flexGrow]="0.5" prop="templateTypeFriendlyName" label="type"></app-column>
    </app-table>
</div>

<app-modal-wrapper
    modalTitle="acl_select_layer"
    modalId="acl-select-layer"
    modalWidth="450">
    <app-modal-body>
        <div class="select-layer-message-wrapper">
            <span>{{ 'acl_select_layer_message' | myLbTranslate }}</span>
        </div>
        <div class="content radio-button-wrapper">
            <input
                type="radio"
                id="layer4"
                tabindex="0"
                [checked]="selectedLayer === 'layer4'"
                (click)="toggleLayer('layer4')">
            <label for="layer4">{{ 'l4' | myLbTranslate }}</label>
            <input
                type="radio"
                id="layer7"
                tabindex="0"
                [checked]="selectedLayer === 'layer7'"
                (click)="toggleLayer('layer7')">
            <label for="layer7">{{ 'l7' | myLbTranslate }}</label>
        </div>
    </app-modal-body>
    <app-modal-footer>
        <app-modal-footer>
            <button
                id="select-acl-layer-close"
                class="outline"
                (click)="closeLayerSelectModal()">
                {{ 'cancel' | myLbTranslate }}
            </button>
            <button
                id="add-acl-layer-close"
                class="primary"
                (click)="confirmLayer()">
                {{ 'confirm' | myLbTranslate }}
            </button>
        </app-modal-footer>
    </app-modal-footer>
</app-modal-wrapper>

<!-- Container used for all modals -->
<ng-container #modalContainer></ng-container>
